<template>
  <ValidationProvider
    v-slot="{ errors }"
    :name="`field_${_uid}`"
    :rules="rules"
  >
    <v-select
      v-if="!isSearchable"
      v-model="fieldValue"
      clearable
      outlined
      flat
      hide-details="auto"
      item-text="label"
      item-value="value"
      :label="fieldLabel"
      :name="fieldLabel"
      :items="items"
      :error-messages="errors"
      :menu-props="{ bottom: true, offsetY: true }"
    ></v-select>

    <v-autocomplete
      v-else
      :ref="fieldLabel"
      v-model="fieldValue"
      clearable
      outlined
      flat
      hide-details="auto"
      item-text="label"
      item-value="value"
      :label="fieldLabel"
      :items="items"
      :error-messages="errors"
      @focus="renderAllOptions"
    ></v-autocomplete>
  </ValidationProvider>
</template>

<script>
import { extend, ValidationProvider } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import i18n from '@/i18n';

import sortCriterias from '@/enum/list-sort-criteria.js';

extend('required', {
  ...required,
  message: i18n.t('validation.fieldIsMandatory')
});

export default {
  props: {
    item: {
      type: Object,
      required: true
    },

    value: {
      type: [String, Number, Object],
      required: false,
      default: ''
    }
  },

  computed: {
    fieldLabel() {
      let label = this.localize(this.item.label);

      // TODO: use enumeration
      if (this.item.fieldValidationMode === 2) {
        label += '*';
      }

      return label;
    },

    fieldValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },

    isSearchable() {
      return this.item.options.length > 15;
    },

    items() {
      const vm = this;
      let options = this.item.options.map((x) => {
        return {
          label: vm.localize(x.label),
          value: x.value
        };
      });

      if (this.item.sortCriteria == sortCriterias.ListSortCriteria.Text) {
        options = options.sort((a, b) => a.label.localeCompare(b.label));
      } else if (
        this.item.sortCriteria == sortCriterias.ListSortCriteria.Value
      ) {
        options = options.sort((a, b) => a.value - b.value);
      }

      return options;
    },

    rules() {
      if (this.item.fieldValidationMode === 2) {
        return 'required';
      }

      return '';
    }
  },

  methods: {
    renderAllOptions() {
      this.$nextTick(() => {
        const autocomplete = this.$refs[this.fieldLabel];
        if (autocomplete) {
          autocomplete.lastItem = this.items?.length ?? Number.MAX_SAFE_INTEGER;
        }
      });
    }
  },

  components: {
    ValidationProvider
  }
};
</script>
